import {Inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, CanActivate, UrlTree} from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
// import {OidcSecurityService} from 'angular-auth-oidc-client';


@Injectable({providedIn: 'root'})
export class ManageLoginGuard implements CanActivate {
  constructor(private router: Router, private oidcSecurityService: OidcSecurityService, private apiService: ApiService) {}

  
  canActivate(): Observable<boolean | UrlTree> {
    
    // Check if the user is authenticated
    return this.oidcSecurityService.checkAuth().pipe(
      map((isAuthenticated) => {
        if (!isAuthenticated.isAuthenticated) {
          return true; // Allow access
        } else {
          this.apiService.isUserAdmin().pipe(
            map((role) => {
              debugger
              if (role || role != false) {
                return this.router.createUrlTree(['/admin/dashboard']);
                // return true;
              } else {
                this.router.createUrlTree(['/forbidden']);
                return false;
              }
            })
          );

          // Redirect to the login page if not authenticated
          // return this.router.createUrlTree(['/admin/dashboard']);
        }
      })
    );
  }
}


//   public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
//     if (this.oidcSecurityService.isAuthenticated() == false || this.cookieService.get('token') == '' || this.cookieService.get('token') == undefined) {
//       return true;
//     } else if (this.cookieService.get('token') != null && this.cookieService.get('token') != '' && this.cookieService.get('token') != undefined) {
//       this.router.navigate(['/user']);
//       return false;
//     } else {
//       this.router.navigate(['/user'])
//       return false;
//     }
//   }
// }